import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import * as Styles from "@universityofmaryland/web-styles-library";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/styles";
import "../../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../../atomic/assets/image/background.js";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import { createTextLockupContact } from "../../../atomic/text-lockup/contact.js";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import { createTextLockupPerson } from "../../../atomic/text-lockup/person.js";
import "../../../atomic/text-lockup/small.js";
const CreatePersonBioFullElement = (props) => {
  const { isThemeDark, image, actions, description } = props;
  const { name, ...textProps } = props;
  const builder = new ElementBuilder().withClassName("person-bio-full-container").withStyles({
    element: {
      [`& .${elementStyles.asset.image.wrapper.className}`]: {
        [`@container (max-width: ${token.media.breakpointValues.medium.max}px)`]: {
          display: "flex"
        }
      }
    }
  });
  if (image) {
    builder.withChild(
      createImageBackground({
        element: image,
        isScaled: false,
        imageLoading: "lazy"
      })
    );
  }
  if (name) {
    builder.withChild(
      new ElementBuilder(name).styled(
        Styles.typography.sans.compose("extralarge", {
          theme: theme.fontColor(isThemeDark)
        })
      ).withStyles({
        element: {
          marginTop: token.spacing.lg,
          textTransform: "uppercase",
          fontWeight: "800",
          display: "block",
          ...!isThemeDark && { color: `${token.color.black}` }
        },
        siblingAfter: {
          marginTop: token.spacing.min
        }
      }).build()
    );
  }
  builder.withChild(
    createTextLockupPerson({
      isThemeDark,
      slotOne: textProps.slotOne,
      slotTwo: textProps.slotTwo,
      slotThreeItalic: textProps.slotThreeItalic,
      slotFour: textProps.slotFour
    })
  );
  builder.withChild(createTextLockupContact(props));
  if (description) {
    builder.withChild(
      new ElementBuilder(description).styled(
        Styles.element.text.rich.composeSimple({
          size: "large",
          theme: theme.fontColor(isThemeDark)
        })
      ).withStyles({
        element: {
          marginTop: token.spacing.lg,
          maxWidth: token.spacing.maxWidth.smallest
        }
      }).build()
    );
  }
  if (actions) {
    builder.withChild(
      new ElementBuilder(actions).styled(Styles.layout.grid.inline.tabletRows).withStyles({
        element: {
          marginTop: token.spacing.sm
        }
      }).build()
    );
  }
  return builder.build();
};
const createCompositePersonBioFull = CreatePersonBioFullElement;
export {
  createCompositePersonBioFull
};
//# sourceMappingURL=full.js.map
